import {GeneralResponse} from "../system/api/Responses";
import {Provider} from "@/models/entities/providers/Provider";
import {Company} from "@/models/entities/providers/Company";
import {MinifiedUserInfo} from "@/models/MinifiedUserInfo";
import {User} from "@/models/entities/users/User";
import {ProviderWorker} from "@/models/entities/providerWorkers/ProviderWorker";

export class UserResponse extends GeneralResponse {
    user:User|null = null
}

export class AddedUserResponse extends GeneralResponse {
    userId:string = ""
}

export class ProviderIdResponse extends GeneralResponse {
    companyId:string = ""
}

export class ProvidersResponse extends GeneralResponse {
    anAbCompaniesInfo:Array<Provider> = [];
}

export class CompaniesResponse extends GeneralResponse {
    companiesInfo:Array<Company> = [];
}

export class ProviderIdCodeResponse extends GeneralResponse {
    companyIdCode:string = "";
}

export class ProviderInfoResponse extends GeneralResponse {
    companyInfo:Provider|null = null
}

export class WorkersResponse extends GeneralResponse {
    companyWorkers:Array<Provider> = []
}

export class MinifiedWorkersResponse extends GeneralResponse {
    userInfos:Array<MinifiedUserInfo> = []
}

export class ProviderWorkerSearchResponse extends GeneralResponse {
    user:ProviderWorker|null = null;
    companyName:string|null = null;
}

export class ExistsResponse extends GeneralResponse {
    isExist:boolean = false
}

export class UrlResponse extends GeneralResponse {
    url:string = ""
}